import React from 'react';
import { Users } from 'lucide-react';
const HERO_BG = 'https://drwzpk38qkpfb.cloudfront.net/www.apc360zone.com/preview/uploaded/images/Redesigne%202024/civilian_bg.jpeg?opt=w3';
export function HeroSection() {
  return <section className="relative py-24 md:py-32 flex items-center border-b border-brand-gray-800 overflow-hidden" data-id="element-292">
      <img src={HERO_BG} alt="Civilian Protection" className="block absolute inset-0 w-full h-full object-cover" onError={e => {
      e.currentTarget.src = 'https://cdn.magicpatterns.com/uploads/6VNDFTEeWuRsoQPUmRUT27/law1.jpg';
    }} data-id="element-293" />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-black/50 via-brand-black/40 to-brand-black z-[1]" data-id="element-294" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 w-full text-center" data-id="element-295">
        <div className="inline-flex items-center gap-2 px-3 py-1 border border-brand-teal/30 bg-brand-teal/10 text-brand-teal text-xs font-bold uppercase tracking-widest mb-6" data-id="element-296">
          <Users className="w-4 h-4" data-id="element-297" />
          Civilian Protection
        </div>
        <h1 className="text-4xl md:text-6xl font-extrabold text-brand-white tracking-tight leading-tight mb-6 uppercase" data-id="element-298">
          Your Right, Your Safety, <br className="hidden md:block" data-id="element-299" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-teal to-brand-teal-light" data-id="element-300">
            Your Responsibility
          </span>
        </h1>
        <p className="text-lg md:text-xl text-brand-gray-300 max-w-2xl mx-auto leading-relaxed" data-id="element-301">
          Practical concealed carry, firearms safety, and personal protection
          training that empowers everyday citizens to defend themselves and
          their families with confidence and responsibility.
        </p>
      </div>
    </section>;
}